import { FC } from 'react';
import { IProps } from './type';
import styles from './index.module.scss';
import { Popover } from 'antd';

const Icon: FC<IProps> = (props) => {
  return (
    <>
      {props.popoverText ? (
        <Popover content={props.popoverText}>
          <img
            className={styles.icon}
            src={props.source}
            alt={props.source.toString()}
            onClick={props.onClick ? props.onClick : () => {}}
          />
        </Popover>
      ) : (
        <img
          className={styles.icon}
          src={props.source}
          alt={props.source.toString()}
          onClick={props.onClick ? props.onClick : () => {}}
        />
      )}
    </>
  );
};

export default Icon;
